<template>
  <div>
    <nav-bar></nav-bar>

    <div class="container main">
      <img src="/img/regular/portfolio-header-03.jpg" />
      <hr />
      <h2>Making future memories...<br />one picture at a time</h2>
      <hr />
      <div class="columns is-6 is-variable">
        <div class="column is-one-third">
          <div class="column-media">
            <img src="/img/jobrina.jpg" />
          </div>
        </div>
        <div class="column">
          <div class="column-content">
            <p>
              I'm Jobrina, and I would love to be your photographer. I enjoy capturing life, not just pictures. Authentic, real, and fun is
              the look I strive for. No one wants the outdated look of stale, overly posed shots! I took my first photography class when I
              was pregnant with my oldest in 2009 and have been capturing memories ever since!
            </p>
            <p>
              I am happily married to my high school sweetheart since 2006 and we have two beautiful children that keep me on my toes and
              actually love to be my models. They were originally why I started this endeavor. I wanted to be able to take plenty of
              pictures of them because I never want to forget all the precious memories of their childhood. Once I started posting their
              photos, others started asking for sessions, and so all this began!
            </p>
            <p>
              Since then, I've spent a lot of time learning! I've come a long way in the process and my skillset. I spend a large amount of
              time learning new things and making sure I'm at my best for YOU. When all this started, I was teaching full time as well.
              After many years of learning, growing, and building a client base, I took a step back from teaching to focus completely on
              photography and started my full-time photography business.
            </p>
            <p>
              My studio is located in Strawberry Plains, Tennessee in Knox County very close to Knoxville, Sevierville, and Jefferson City,
              but happily serve all surrounding cities and counties! I shoot on location in Knoxville primarily but love Sevierville, Kodak,
              Morristown, and Jefferson City, just to name a few!
            </p>
            <p>
              If you're looking for a photographer to capture all your lives' little moments, look no further. At J. Ellison Photography, we
              can make sure every moment be it your perfect wedding day that you've dreamed about to your precious newborn's squishy, cuddly
              images, all the way to their senior session are captured in a way that you'll love for years to come. I love getting to know
              my clients and watch everyone grow and change. Don't miss out on the memories that will be gone tomorrow.
            </p>
            <p>Thank you for considering me to help capture your life.</p>
          </div>
        </div>
      </div>
    </div>

    <footer-nav></footer-nav>
  </div>
</template>

<script>
import NavBar from '../components/navbar.vue';
import FooterNav from '../components/footer.vue';

export default {
  components: {
    NavBar,
    FooterNav
  }
};
</script>

<style></style>
